import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useContext, useRef } from "react";
import { checkWindow } from "@vfit/shared/data-access";
import GlobalContext from "../../context/Global";
import { RoundedImage, SeeMoreContent } from "./SeeMore.style";
import { truncateString } from "./SeeMore.utils";
var SeeMore = function(param) {
    var seeMoreContent = param.seeMoreContent;
    var keyboardNavigation = useContext(GlobalContext).keyboardNavigation;
    var checkBoxRef = useRef(null);
    var image = seeMoreContent.image, fullName = seeMoreContent.fullName, text = seeMoreContent.text, seeMoreLabel = seeMoreContent.seeMoreLabel, hideLabel = seeMoreContent.hideLabel;
    useEffect(function() {
        if (checkWindow() && typeof keyboardNavigation === "boolean" && keyboardNavigation) {
            document.addEventListener("keydown", handleKeyDown);
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        keyboardNavigation
    ]);
    var handleKeyDown = function(e) {
        if (e.key === "ArrowUp") {
            var ref, ref1;
            e.preventDefault();
            if (!(checkBoxRef === null || checkBoxRef === void 0 ? void 0 : (ref = checkBoxRef.current) === null || ref === void 0 ? void 0 : ref.checked)) checkBoxRef === null || checkBoxRef === void 0 ? void 0 : (ref1 = checkBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.click();
        } else if (e.key === "ArrowDown" || e.key === "Escape") {
            var ref2, ref3;
            e.preventDefault();
            if (checkBoxRef === null || checkBoxRef === void 0 ? void 0 : (ref2 = checkBoxRef.current) === null || ref2 === void 0 ? void 0 : ref2.checked) checkBoxRef === null || checkBoxRef === void 0 ? void 0 : (ref3 = checkBoxRef.current) === null || ref3 === void 0 ? void 0 : ref3.click();
        }
    };
    return /*#__PURE__*/ _jsx(SeeMoreContent, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card",
            children: [
                /*#__PURE__*/ _jsx("input", {
                    ref: checkBoxRef,
                    id: "ch",
                    type: "checkbox"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "top",
                    children: [
                        /*#__PURE__*/ _jsx(RoundedImage, {
                            img: image
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fullname",
                            children: fullName
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "smallText",
                    children: truncateString(text, 105)
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: text
                        }),
                        /*#__PURE__*/ _jsx("label", {
                            htmlFor: "ch",
                            children: hideLabel
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("label", {
                    htmlFor: "ch",
                    children: seeMoreLabel
                })
            ]
        })
    });
};
export default SeeMore;
